import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useChatHistory } from "../../ChatHistoryProvider";
import { faMessage, faEllipsisH } from "@fortawesome/free-solid-svg-icons";
import { useState, useEffect, useRef } from "react";
import settings from "../../settings";
const { REACT_APP_BACKEND_URL } = settings;

const ChatSessions = () => {
    const { chatHistory, changeSelectedChat, selectedChat, loading, newChat } = useChatHistory();
    const [expandedChat, setExpandedChat] = useState<string | null>(null); // Track which session is expanded
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [selectedForDelete, setSelectedForDelete] = useState<string | null>(null);
    const { deleteChat } = useChatHistory();

    const dummyChats = Array.from({ length: 5 }, (_, index) => ({
        id: `dummy-${index}`,
        title: `Loading...`,
    }));

    const chatsToDisplay = loading ? dummyChats : chatHistory;

    const toggleExpand = (chatId: string) => {
        setExpandedChat(expandedChat === chatId ? null : chatId); // Toggle session expansion
    };

    const handleDelete = (chatId: string) => {
        setConfirmDelete(true);
        setSelectedForDelete(chatId);
    };

    const confirmDeletion = async () => {
        if (selectedForDelete) {
            try {
                const token = localStorage.getItem('access_token');
                const response = await fetch(`${REACT_APP_BACKEND_URL}/chat/session/${selectedForDelete}`, {
                    method: "DELETE",
                    headers: { Authorization: `Bearer ${token}` },
                });

                if (response.ok) {
                    deleteChat(selectedForDelete);
                    if (selectedChat?.id == selectedForDelete){
                        newChat();
                    }
                } else {
                    console.error("Failed to delete chat session.");
                }
            } catch (error) {
                console.error("Error deleting chat:", error);
            } finally {
                setConfirmDelete(false);
                setSelectedForDelete(null);
            }
        }
    };

    return (
        <>
            {chatsToDisplay.map((chat) => (
                <div key={chat.id} className="relative">
                    {/* Chat session container */}
                    <a
                        onClick={() => !loading && changeSelectedChat(chat.id)}
                        className={`flex py-3 px-3 items-center gap-3 rounded-md cursor-pointer break-all 
                        ${selectedChat?.id === chat.id && !loading ? "bg-[#2564eba7] text-white" : "hover:bg-[#2A2B32]"}
                        ${loading ? "animate-pulse bg-gray-600 cursor-default" : ""}
                      `}
                        style={{ pointerEvents: loading ? "none" : "auto" }}
                    >
                        <FontAwesomeIcon icon={faMessage} />
                        <div className="flex-1 text-ellipsis max-h-5 overflow-hidden break-all relative">
                            {chat.title}
                        </div>
                        <button
                            className="text-gray-400 hover:text-white px-2"
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleExpand(chat.id); // Expand or collapse the session
                            }}
                        >
                            <FontAwesomeIcon icon={faEllipsisH} />
                        </button>
                    </a>

                    {/* Expanded chat session (dropdown) */}
                    <div
                        className={`overflow-hidden transition-[max-height] duration-300 ease-in-out bg-[#333] text-white text-xs rounded-md shadow-lg mt-1
                        ${expandedChat === chat.id ? "max-h-40" : "max-h-0"}`}
                    >
                        <div className="p-1">
                            {/* Dropdown content (Delete button or any other actions) */}
                            <ul className="text-center">
                                <li
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleDelete(chat.id);
                                    }}
                                    className="px-4 py-2 hover:bg-red-600 hover:text-white cursor-pointer rounded-md"
                                >
                                    Delete Chat
                                </li>
                                {/* Add more options here if needed */}
                            </ul>
                        </div>
                    </div>
                </div>
            ))}

            {/* Confirmation dialog */}
            {confirmDelete && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
                    <div className="bg-gray-800 p-6 rounded-md shadow-lg w-100">
                        <h1 className="text-white text-lg font-extrabold mb-4">Delete chat?</h1>

                        <hr className="border-gray-600 mb-4" />

                        <p className="text-white text-lg mb-4">
                            You are about to delete the session:{" "}
                            {selectedForDelete && (
                                <strong>
                                    {chatHistory.find((chat) => chat.id === selectedForDelete)?.title}
                                </strong>
                            )}
                        </p>

                        <div className="flex justify-end space-x-4">
                            <button
                                className="px-4 py-2 bg-gray-600 rounded-md hover:bg-gray-700"
                                onClick={() => setConfirmDelete(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="px-4 py-2 bg-red-600 rounded-md hover:bg-red-700"
                                onClick={confirmDeletion}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ChatSessions;
